import React from "react";
import { Modal } from "react-bootstrap";
const PhotoViewer = props => {
  return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <img className="image-modal" src={props.image} alt="..." />
          </Modal>
  );
};

export default PhotoViewer;
